import { useState } from 'react';
import { useField } from 'formik';
import { Stack } from '@koob/margaret';
import { KoobFormikInput, KoobInputLabel } from '@koob/ui';
import {
  FormField,
  FormLabel,
  ErrorMessageWrapper,
  HelperText,
} from 'ui/forms';
import { uniqueId } from 'lodash';
import { Asterix } from './Base';

const TextField = ({
  label,
  labelSuffix,
  variant = '',
  helperText,
  touchRequired = true,
  required,
  suffixIcon,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const [id] = useState(uniqueId());

  const hasError =
    (!touchRequired || Boolean(meta.touched)) && Boolean(meta.error);

  const renderInput = iconRight => (
    <KoobFormikInput
      field={field}
      setValue={helpers.setValue}
      {...props}
      error={hasError}
      id={id}
      iconRight={iconRight}
    />
  );

  if (variant === 'inline') {
    return (
      <Stack alignY="center" gutterSize={label ? 0.5 : 0}>
        <FormLabel variant="bare" htmlFor={id}>
          {label} {required && <Asterix />}
        </FormLabel>
        <Stack>{renderInput()}</Stack>
      </Stack>
    );
  }

  return (
    <FormField>
      {labelSuffix
        ? (Boolean(label) || Boolean(labelSuffix)) && (
            <Stack
              alignX="space-between"
              alignY="center"
              marginBottom={0.5}
              size="full"
            >
              {label && (
                <FormLabel variant="bare" htmlFor={id}>
                  {label} {required && <Asterix>*</Asterix>}
                </FormLabel>
              )}
              {labelSuffix}
            </Stack>
          )
        : Boolean(label) && (
            <KoobInputLabel htmlFor={id} label={label} required={required} />
          )}

      <Stack size="full">
        <div style={{ width: '100%' }}>{renderInput(suffixIcon)}</div>
        {hasError && <ErrorMessageWrapper>{meta.error}</ErrorMessageWrapper>}
      </Stack>
      {Boolean(helperText) && <HelperText>{helperText}</HelperText>}
    </FormField>
  );
};

export default TextField;
